import React from 'react';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  styled,
} from '@mui/material';
import ArrowIcon from '@mui/icons-material/ArrowForwardIosSharp';

type Props = React.PropsWithChildren<{
  title: string;
  contentClassname?: string;
}>;

const AccordionContainer = styled((props: any) => (
  <MuiAccordion disableGutters elevation={1} square children={null} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': { borderBottom: 0 },
  '&::before': { display: 'none' },
}));
const Icon = <ArrowIcon sx={{ fontSize: '1rem', color: '#000' }} />;
const AccordionHeader = styled((props) => <MuiAccordionSummary expandIcon={Icon} {...props} />)(
  () => {
    return {
      padding: 0,
      paddingLeft: 8,
      border: 'none',
      margin: 0,
      borderRadius: 11,
      backgroundColor: 'var(--color-primary-50)',
      flexDirection: 'row-reverse',
      '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
      },
      '& .MuiAccordionSummary-content': {
        marginLeft: 8,
        fontSize: 14,
        fontWeight: 500,
        color: 'var(--color-greyscale-800)',
      },
      svg: {
        color: 'var(--color-greyscale-800)',
      },
    };
  },
);

const Details = styled((props) => <AccordionDetails {...props} />)(() => ({
  padding: 0,
}));

export function NexlaAccordion({ title, children, contentClassname }: Props) {
  return (
    <AccordionContainer>
      <AccordionHeader>{title}</AccordionHeader>
      <Details>
        <div aria-label="NexlaAccordion-content" className={contentClassname}>
          {children}
        </div>
      </Details>
    </AccordionContainer>
  );
}
